import React from "react";
import { withTranslation } from 'react-i18next';
// import { Trans } from 'react-i18next';
import { connect } from "react-redux";
import mapStateToProps from "reducers/actions/stateToProps";
import mapDispatchToProps from "reducers/actions/dispatchProps";
import Constants from "components/utils/constants";
import LoadingOverlay from "components/common/loadingOverlay";
import { Button } from "@material-ui/core";
import { withSnackbar } from "notistack";
import { concat as _concat, cloneDeep as _cloneDeep } from "lodash";
import { AccountHandler, SubscriberHandler } from "chits-data/dist";
import SubscribersManager from "components/subscriber/SubscribersManager";
import moment from "moment-timezone";
import { WebClientStore } from "web-client-store";
let { Session } = WebClientStore;
let console = Constants.consoleWrapper(false);
let { SESSION_KEYS } = Constants;

class Members extends React.Component {
  constructor(props) {
    super(props);
    this._isMounted = false; // prevents -> Warning: Can't perform a React state update on an unmounted component
    this._accountHandler = new AccountHandler();
    this._subscriberHandler = new SubscriberHandler();
  }

  state = {
    open: {
      widgetYearlyTrends: false,
      widgetTranTypeSplits: false,
    },
    roles: {
      owner: false,
      admin: false,
      editor: false,
      viewer: false,
      any: false,
    },
    showAccountInfo: true,
    accountInfoReadOnly: true,
    showAccountChitInfo: true,
    accountChitInfoReadOnly: true,
    openOverlay: false,
    accountLineUp: [Constants.DEFAULT_ACCOUNT],
    selectedAccount: Constants.DEFAULT_ACCOUNT,
    currentAction: "info",
    accountReceipts: [],
    termStarted: false,
    displayAccountSchedule: false,
    enableAccountSchedule: false,
    displayAccountSummary: true,
    enableAccountStmtSummary: false,
  };

  componentDidMount = () => {
    //TODO: If this page accessed without account set; redirect to /info
    let ac = this._accountHandler.getActiveAccount();
    // asynchronously load account information to props
    this._accountHandler.getAccountCached(ac).then((account) => {
      if (account){
        this.props.setCurrentAccount(account);
        this.setState({ roles: Constants.extractRolesFromAccount(account)})
      }
    });
  };

  _force_reload_account = () => {
    return this._accountHandler
      .getAccountCached(this.props.wallet.current._id, true)
      .then((ac) => {
        // console.log('AccountInfo->renderActionInfoForm->AFTER ac', ac);
        this.setState({ selectedAccount: ac });
        // force-refresh transactions on next visit to transactions page
        Session.set(
          this.props.wallet.current._id + "_req_ts",
          moment().format("YYYYMMDDhhmmss")
        );
        // window.location.reload();
      });
  };

  renderModalSubscriberManager() {
    let { wallet, t } = this.props;
    let { current } = wallet;
    console.debug('current', current)
    if (current._id === 'default') return;

    let subCnt = 0;
    if (current.subscribers) subCnt = Object.keys(current.subscribers).length;
    console.debug("subCnt", subCnt);

    // if term = -1; chit matured
    // if term > 1; chit is active
    // if term = 1; chit is inactive
    // if term = undefined; chit not  yet started
    let chitNew = current.chit_info.nextTerm === undefined;
    let chitInitiated = !chitNew && current.chit_info.nextTerm === 1;
    let chitActive = !chitNew && current.chit_info.nextTerm > 1;
    let chitMatured = !chitNew && current.chit_info.nextTerm === -1;
    console.debug('chitInitiated', chitInitiated);
    console.debug('chitActive', chitActive);
    console.debug('chitMatured', chitMatured);

    return (
        <div className="card" style={{ marginTop: "1em", marginBottom: "1em" }}>
          <div
            className="card-header"
            style={{ padding: "6px 4px 0px 10px", fontSize: "smaller" }}
          >
            {/* {subCnt === 0 && (
              <Button
                color="primary"
                variant="contained"
                onClick={() => {
                  this._accountHandler
                    .addDummySubscribers(current._id)
                    .then(() => {
                      this._force_reload_account().then(() => {
                        window.location.href += "?refresh=1";
                      });
                    });
                }}
              >
                Setup Subscribers
              </Button>
            )} */}
            {subCnt > 0 && (chitNew || chitInitiated) && (
              <Button
                color="primary"
                variant="contained"
                onClick={() => {
                  this._subscriberHandler.unAssignAllSubscribersToChitfund(current._id)
                  .then(()=>{
                    this._accountHandler
                    .addDummySubscribers(current._id)
                    .then(() => {
                      this._force_reload_account().then(() => {
                        window.location.href += "?refresh=1";
                      });
                    });
                  })
                }}
                disabled={!(this.state.roles.admin || this.state.roles.owner)}
              >
                Reset All
              </Button>
            )}
            {/* {false &&
              !this.state.termStarted &&
              this.state.selectedAccount.subscribers && (
                <Button
                  color="secondary"
                  variant="contained"
                  onClick={() => {
                    this._accountHandler
                      .startTheChit(this.state.selectedAccount._id)
                      .then(() => {
                        this._force_reload_account().then(() => {
                          window.location.href += "?refresh=1";
                        });
                      });
                  }}
                >
                  Start The chit
                </Button>
              )} */}
            {(
                
                <Button
                  color="default"
                  variant="contained"
                  onClick={() => {
                    window.location.href += "?refresh=refresh_members";
                  }}
                >
                  {t('Refresh')}
                </Button>
              )}
            {chitActive && (<><br />
              <span>
                Note: Chit has been started. To Edit a subscriber name, double
                click, type and hit Enter.
              </span></>
            )}
            {chitMatured && (<><br />
              <span>
                Note: Chit has been closed. Not further edits possible.
              </span></>
            )}
          </div>
          <div className="card-body" style={{ padding: "4px 1px 2px 2px" }}>
            <SubscribersManager
              display={true}
              selectedAccount={this.props.wallet.current}
              roles={this.state.roles}
            />
          </div>
        </div>
    );
  }

  render() {
    let { wallet, t } = this.props;
    return (
      <div className="content-fluid">
        <div className="row">
          <div
            className={
              this.state.currentAction === "info"
                ? "col-md-9 mx-auto"
                : "col-md-9 mx-auto"
            }
          >
            <div className="card">
              <div
                className="card-header"
                style={{
                  paddingLeft: "1em",
                  paddingRight: "1em",
                  paddingTop: "1em",
                  textAlign: "center",
                }}
              >
                <h4 className="card-title">{t('Chitfund Members')}</h4>
                <p
                  className="card-category"
                  style={{ color: "#9C27B0", fontWeight: "500" }}
                >
                  {wallet.current.name}
                </p>
              </div>
              <div className="card-body" style={{ padding: "4px" }}>
                {this.renderModalSubscriberManager()}
                {this.state.openOverlay && <LoadingOverlay />}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withSnackbar(
  withTranslation()(
    Members
  )
));
